import { Injectable } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/auth';
import { Router } from '@angular/router';
import { CommanService } from './comman.service';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private uid;
  private user;
  constructor(private auth: AngularFireAuth, public router: Router, public admin: CommanService) {
    if(localStorage.getItem('uid')){
      this.uid = localStorage.getItem('uid')
    }
    this.getAuthState();
   }

  // tslint:disable-next-line: one-line
  signin(email, password){
    this.auth.auth.signInWithEmailAndPassword(email, password).then(res => {
      this.uid = res.user.uid;
      this.user = res.user;
      localStorage.setItem('uid',this.uid)
      this.router.navigateByUrl('/home');
    }).catch(err => {
      this.admin.showToast('danger', 'Error', err);
    });
  }
  // tslint:disable-next-line: one-line
  getUid(){
    return this.uid;
  }
  // tslint:disable-next-line: one-line
  isAuthenticated(){
    // tslint:disable-next-line: one-line
    if (this.uid ){
      return true;
    }
    // tslint:disable-next-line: one-line
    else {
      return false;
    }
  }

  // tslint:disable-next-line: one-line
  getAuthState(){
    this.auth.authState.subscribe(res => {
      if (res)
      // tslint:disable-next-line: one-line
      {
        if (res.uid) {
          this.uid = res.uid;
          this.user = res;
          localStorage.setItem('uid',this.uid)
        //  this.router.navigateByUrl('/home');
        }
      }

    });
  }
  // tslint:disable-next-line: one-line
  getUserEmail(){
    return this.user.email;
  }
  // tslint:disable-next-line: one-line
  logout(){
    this.auth.auth.signOut().then(res => {
      this.uid = null;
      localStorage.removeItem('uid')
      this.user = null;
      location.href = '';
    });

  }
}
